﻿<itp-panel>
    <list-vat-countries [legalEntityId]="legalEntityId"></list-vat-countries>
</itp-panel>